import { configureStore } from '@reduxjs/toolkit';
import TasksSlice from './Slices/TasksSlice';
import CategorySlice from './Slices/CategorySlice';

export const store = configureStore({
    reducer: {
        tasksReducer: TasksSlice,
        categoriesReducer: CategorySlice,
        
    },
});
